<svg
  [attr.width]="size()"
  [attr.height]="size()"
  viewBox="0 0 64 64"
  fill="currentColor"
  role="img"
  aria-label="Taolo"
>
  <rect x="8" y="12" width="48" height="10" />
  <rect x="14" y="28" width="12" height="24" />
</svg>
